import { Box, Typography, Button, Stack } from "@mui/material";
import {
  Home as HomeIcon,
  Search as SearchIcon,
  Description as ProjectDraftsIcon,
  Work as MyProjectsIcon,
  MenuBook as TrainingCenterIcon,
  Article as NewsIcon,
  Apps as ResourcesIcon,
} from "@mui/icons-material";
import React from "react";
import { NavLink } from "react-router-dom";

const LeftBar = ({ style, data: jsonData }) => {
  const mainNavData = [
    {
      label: "Home",
      path: "/",
      icon: <HomeIcon />,
      active: false,
    },
    {
      label: "Search",
      path: "/Client",
      icon: <SearchIcon />,
    },
    {
      label: "Project Drafts",
      path: "/project-drafts",
      icon: <ProjectDraftsIcon />,
    },
    {
      label: "My Projects",
      path: "/my-projects",
      icon: <MyProjectsIcon />,
    } 
  ];

  const corporateAssetsData = [
    {
      label: "Training Center",
      path: "/training-center",
      icon: <TrainingCenterIcon />,
    },
    {
      label: "News",
      path: "/news",
      icon: <NewsIcon />,
    },
    {
      label: "Resources",
      path: "/resources",
      icon: <ResourcesIcon />,
    },
  ];

  return (
 <Stack width={237}   >

     <Box
      sx={{
        width: 237,
        minHeight: "100vh",
        height: "100%",
        backgroundColor: "#FFF8F9",
        display: "flex",
        flexDirection: "column",
        position: "fixed",
  
        justifyContent:"space-between",
        zIndex: 1000,
        borderRight: "1px solid #e0d4e4",
     
        ...style,
      }}
    >
      <Box 
      sx={{ 
        flex: 1, 
        pt: 3, 
        px: 2, 
        overflowY: "auto", 
        paddingBottom: "200px", 
        "&::-webkit-scrollbar": {
          width: "1px",
        },
        "&::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "rgba(96, 19, 80, 0.2)",
          borderRadius: "2px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "rgba(96, 19, 80, 0.3)",
        },
     
        scrollbarWidth: "auto",
        scrollbarColor: "rgba(96, 19, 80, 0.2) transparent",
      }}>
        {mainNavData?.map((el, i) => (
          <Box key={i} sx={{ mb: 1 }}>
            <NavLink
              to={el.path}
              style={{
                textDecoration: "none",
                display: "block",
                width: "100%",
              }}
            >
              {({ isActive }) => (
                <Button
                  fullWidth
                  startIcon={el.icon}
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",
                    py: 1.5,
                    px: 3,
                    borderRadius: 8,
                    backgroundColor:
                      isActive || el.active
                        ? "rgba(96, 19, 80, 0.16)"
                        : "transparent",
                    color: "#51434B",
                    fontSize: "14px",
                    fontWeight: isActive || el.active ? 600 : 500,
                    "&:hover": {
                      backgroundColor:
                        isActive || el.active
                          ? "rgba(96, 19, 80, 0.16)"
                          : "#f0ecf1",
                    },
                    "& .MuiButton-startIcon": {
                      marginRight: 2,
                      color: "#51434B",
                    },
                  }}
                >
                  {el.label || el.name || `Item ${i + 1}`}
                </Button>
              )}
            </NavLink>
          </Box>
        ))}
      </Box>

      <Box sx={{ 
        borderTop: "1px solid #e0d4e4", 
        position: "fixed",
        bottom: 0, 
   
        backgroundColor: "#FFF8F9",
        pt: 3, 
        pb: 3, 
        px: 2 
      }}>
        <Typography
          variant="body2"
          sx={{
            px: 3,
            mb: 2,
            color: "#666",
            fontWeight: 600,
            fontSize: 13,
            textTransform: "uppercase",
            letterSpacing: 0.5,
          }}
        >
          Corporate Assets
        </Typography>

        {corporateAssetsData?.map((el, i) => (
          <Box key={i} sx={{ mb: 1 }}>
            <NavLink
              to={el.path || "#"}
              style={{
                textDecoration: "none",
                display: "block",
                width: "100%",
              }}
            >
              {({ isActive }) => (
                <Button
                  fullWidth
                  startIcon={el.icon}
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",
                    py: 1.5,
                    px: 3,
                    borderRadius: 8,
                    backgroundColor: isActive
                      ? "rgba(96, 19, 80, 0.16)"
                      : "transparent",
                    color: "#51434B",
                    fontSize: 14,
                    fontWeight: isActive ? 600 : 500,
                    "&:hover": {
                      backgroundColor: isActive
                        ? "rgba(96, 19, 80, 0.16)"
                        : "#f0ecf1",
                    },
                    "& .MuiButton-startIcon": {
                      marginRight: 2,
                      color: "#51434B",
                    },
                  }}
                >
                  {el.label || el.name || `Item ${i + 1}`}
                </Button>
              )}
            </NavLink>
          </Box>
        ))}
      </Box>
    </Box>
 </Stack>
  );
};

export default LeftBar;
